import React, { useEffect, useState } from "react";
import LoadingBar from "react-top-loading-bar";
import { AppRouteUi, CallCenterActivityTypeOptions, ExportTableType, PaginationSettings, topLoaderProgress, } from "../../configs";
import { AdminPageTemplate, ColumnToolTip, ModalCallSummary, } from "../../features";
import { useFunctionalityCallCenterActivity } from "../hooks/functionalityCallCenterActivity";
import { useAppSelector, VRIAppStateType } from "../../core";
import ReactDOM from "react-dom";
import { ColumnSelectionsModel, TableColumnExtend } from "../../models";
import { CallCenterActivityColumns } from "../../configs/AppJson/CallCenterActivityColumns";
import moment from "moment";
import { ApiSchemaFilter } from "../../models/api/filter";
import { ApiSchemaCallCenterActivityData } from "../../models/api/CallCenterActivity";
import { Link } from 'react-router-dom';
import { CallSummaryResponseModel } from "../../models/api/Call";
import { useFunctionalityCallSummary } from "../hooks";
import { AssetSvg } from "../../assets";

export function PageActivity() {
  const callCenterId = useAppSelector(
    (state: VRIAppStateType) => state.auth.menuSettings?.callCenterSettings.callCenterId
  );
  const [show, setShow] = useState<boolean>(false);
  const [callSummaryData, setCallSummaryData] = useState<CallSummaryResponseModel>();
  const { LoadById } = useFunctionalityCallSummary();
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [isShowCommonFilter, setIsShowCommonFilter] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);
  const [columnSelection, setColumnSelection] = useState<ColumnSelectionsModel[]>(CallCenterActivityColumns);
  const [columnSelectionModalShow, setColumnSelectionModalShow] = React.useState(false);

  let initialFilterData: ApiSchemaFilter = {
    filterQueries: [],
    sortQuery: {},
  };
  const [filterData, setFilterData] = useState<ApiSchemaFilter>(initialFilterData);
  const [filterDataChange, setFilterDataChange] = useState<number>(0);
  const [fetchIsStale, setFetchIsStale] = useState(false);

  const {
    pagedActivityList,
    pagedActivityListCount,
    pagedCallCenterActivityUrl,
    lastUpdated
  } = useFunctionalityCallCenterActivity({
    callCenterId: callCenterId || "",
    pageSize: pageSize,
    pageNo: pageIndex,
    searchText: searchText?.trimStart(),
    setLoaderProgress,
    filterData: filterData,
    filterDataChange: filterDataChange,
  });

  useEffect(() => {
    if (pagedActivityListCount) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedActivityList]);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const handleShowCallSummary = (callId: string) => {
    if (callId) {
      setLoaderProgress(topLoaderProgress.start);
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>> LoadbyId from ActivityPage");
      LoadById(callId).then((data) => {
        if (data?.id) {
          setLoaderProgress(topLoaderProgress.complete);
          setCallSummaryData(data);
          setShow(true);
        }
      });
    }
  };

  const fromOADate = (oadate: number) => {
    const millis = (oadate - 25569) * 86400000;
  
    const tzOffset = new Date().getTimezoneOffset() * 60000;

    return new Date(millis + tzOffset);
  };
  


  function formatDate(date: Date | null): string {
    if (date == null){
      return "loading"
    }
    else{
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).replace(",", "");
  }
  }

    useEffect(() => {
      const interval = setInterval(() => {
        if (!lastUpdated) return;
  
        const now = new Date();
        const diffInSeconds = (now.getTime() - lastUpdated.getTime()) / 1000;
  
        setFetchIsStale(diffInSeconds > 20);
      }, 2000); 
  
      return () => clearInterval(interval);
    }, [lastUpdated]);
  
  const activityTableColumns: TableColumnExtend<ApiSchemaCallCenterActivityData>[] =
    [
      {
        name: <ColumnToolTip data="Name" />,
        sortable: true,
        sortField: "Actor.Name",
        selector: (row: ApiSchemaCallCenterActivityData) => {
          return (
            <Link to={AppRouteUi.Operator.Profile.Load(row.operatorId ?? "")}>
              <ColumnToolTip data={row.name ?? ""} />
            </Link>
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Name")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Email" />,
        selector: (row: ApiSchemaCallCenterActivityData) => {
          return <ColumnToolTip data={row.email ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Email")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Platform Type" />,
        selector: (row: ApiSchemaCallCenterActivityData) => {
          return <ColumnToolTip data={row.platformtype ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "PlatformType")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Activity" />,
        selector: (row: ApiSchemaCallCenterActivityData) =>
          CallCenterActivityTypeOptions.find(
            (name: any) => name.value === row?.activity
          )?.label ?? "-",
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Action")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Device" />,
        sortable: true,
        sortField: "DeviceOs",
        selector: (row: ApiSchemaCallCenterActivityData) => {
          return <ColumnToolTip data={row.device ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Device")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Date Time" />,
        sortable: true,
        sortField: "CreatedAt",
        selector: (row: ApiSchemaCallCenterActivityData) => {
          const date = row.dateTime ? fromOADate(row.dateTime) : null;
      
          return (
            <ColumnToolTip
              data={date ? moment(date).format("MMM DD, YYYY HH:mm:ss") : "-"}
            />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "DateTime")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Details" />,
        selector: (row: ApiSchemaCallCenterActivityData) => (
          <>
            {row.callId && (
              <div
                className="btn svg-color"
                title="Edit"
                onClick={() => handleShowCallSummary(row.callId ?? "")}
              >
                <span >
                  <AssetSvg.ViewProfile />
                </span>
              </div>
            )}
            {row.description && (
              <ColumnToolTip
                data={
                  row.description
                }
              />
            )}
          </>
        ),
      },
    ];
  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />

      <div className="d-flex align-items-end justify-content-end">
        <small style={{ color: fetchIsStale ? "red" : "grey" }}>Last fetched on: {formatDate(lastUpdated)}</small>
      </div>
      <AdminPageTemplate
        pagingKey="PageActivity"
        loaderProgress={loaderProgress}
        showExportOptions={true}
        showFilter={true}
        filterPanel={"commonAuditActivityFilterPanel"}
        pageBreadCrumbTile="Call Center"
        pageTitle="Activity"
        tableHeaders={activityTableColumns}
        tableData={pagedActivityList || []}
        searchText={searchText}
        handleSearch={handleSearch}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        count={pagedActivityListCount}
        onChangePageIndex={onChangePageIndex}
        onChangePageSize={onChangePageSize}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
        columnSelectionModalShow={columnSelectionModalShow}
        setColumnSelectionModalShow={setColumnSelectionModalShow}
        columnSelection={columnSelection}
        setColumnSelection={setColumnSelection}
        setFilterDataForAnyTable={setFilterData}
        setFilterDataChangeForAnyTable={setFilterDataChange}
        filterDataChange={filterDataChange}
        pageName="activityPage"
        tableType={ExportTableType.CallCenterActivityLog}
        downloadedFileName={"CallCenterActivityLog Report"}
        callCenterId={callCenterId}
        filterData={filterData}
        setLoaderProgress={setLoaderProgress}
        showAutoRefresh={true}
        mutateUrl={pagedCallCenterActivityUrl}
        setIsShowCommonFilter={setIsShowCommonFilter}
        isShowCommonFilter={isShowCommonFilter}
      />
      <ModalCallSummary
        summary={callSummaryData}
        show={show}
        handleShow={setShow}
        onRefreshSummary={setCallSummaryData}
      />
    </>
  );
}
